/** True when API provides a refundable amount (not `null` / omitted). */
export function hasPaymentRefundableAmount(
  payment: Record<string, unknown> | null | undefined,
): boolean {
  if (payment == null) return false;
  const raw =
    payment.refundableamount ??
    payment.refundableAmount ??
    payment.RefundableAmount;
  return raw != null;
}
